package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AcademicYearResponse(
    @SerialName("school_id")
    val schoolId: String? = null,
    @SerialName("label")
    val label: String? = null,
    @SerialName("start_date")
    val startDate: String? = null,
    @SerialName("end_date")
    val endDate: String? = null,
    @SerialName("is_active")
    val isActive: Boolean? = null,
    @SerialName("lifecycle")
    val lifecycle: String? = null,
    @SerialName("id")
    val id: String? = null,
    @SerialName("created_at")
    val createdAt: String? = null,
    @SerialName("created_by_id")
    val createdById: String? = null,
    @SerialName("created_by_name")
    val createdByName: String? = null,
    @SerialName("updated_at")
    val updatedAt: String? = null,
    @SerialName("updated_by_id")
    val updatedById: String? = null,
    @SerialName("updated_by_name")
    val updatedByName: String? = null
)

@Serializable
data class AcademicYearWithSchoolResponse(
    @SerialName("school_id")
    val schoolId: String? = null,
    @SerialName("label")
    val label: String? = null,
    @SerialName("start_date")
    val startDate: String? = null,
    @SerialName("end_date")
    val endDate: String? = null,
    @SerialName("is_active")
    val isActive: Boolean? = null,
    @SerialName("lifecycle")
    val lifecycle: String? = null,
    @SerialName("id")
    val id: String? = null,
    @SerialName("created_at")
    val createdAt: String? = null,
    @SerialName("created_by_id")
    val createdById: String? = null,
    @SerialName("created_by_name")
    val createdByName: String? = null,
    @SerialName("updated_at")
    val updatedAt: String? = null,
    @SerialName("updated_by_id")
    val updatedById: String? = null,
    @SerialName("updated_by_name")
    val updatedByName: String? = null,
    @SerialName("school_name")
    val schoolName: String? = null
)

@Serializable
data class AcademicYearAnalyticsResponse(
    val timestamp: String = "",
    val scope: String = "",
    val metrics: AcademicYearAnalyticsMetrics = AcademicYearAnalyticsMetrics()
)

@Serializable
data class AcademicYearAnalyticsMetrics(
    @SerialName("total_academic_years")
    val totalAcademicYears: Int = 0,
    @SerialName("active_years")
    val activeYears: Int = 0,
    @SerialName("inactive_years")
    val inactiveYears: Int = 0,
    @SerialName("closed_years")
    val closedYears: Int = 0,
    @SerialName("upcoming_years")
    val upcomingYears: Int = 0,
    @SerialName("current_years")
    val currentYears: Int = 0
)
